(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSBajaDialogController', SSBajaDialogController);

    SSBajaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'SSBaja', 'SSAsignacion'];

    function SSBajaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, SSBaja, SSAsignacion) {
        var vm = this;

        vm.sSBaja = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.asignacions = SSAsignacion.query({filter: 'ssbaja-is-null'});
        $q.all([vm.sSBaja.$promise, vm.asignacions.$promise]).then(function() {
            if (!vm.sSBaja.asignacion || !vm.sSBaja.asignacion.id) {
                return $q.reject();
            }
            return SSAsignacion.get({id : vm.sSBaja.asignacion.id}).$promise;
        }).then(function(asignacion) {
            vm.asignacions.push(asignacion);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sSBaja.id !== null) {
                SSBaja.update(vm.sSBaja, onSaveSuccess, onSaveError);
            } else {
                SSBaja.save(vm.sSBaja, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('serviciosocialApp:sSBajaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaBaja = false;
        vm.datePickerOpenStatus.altaReg = false;
        vm.datePickerOpenStatus.bajaReg = false;
        vm.datePickerOpenStatus.ultActReg = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
